import { _ as _extends } from '../../_rollupPluginBabelHelpers-c245b26a.js';
import { forwardRef } from 'react';
import { themed } from '@indeed/ifl-css';
import transition from '../../utils/transition.js';
import createResponsive from '../../utils/createResponsive.js';
import { disabledStyles, focusStyles } from '../../utils/styled.js';
import { ChevronUp, ChevronDown } from '@indeed/ifl-icons';
import { jsx } from '@emotion/react';
import { Flex } from '../Flex/Flex.js';
import { Box } from '../Box/Box.js';

// ----------------------
// SIZES
// ----------------------

const sizes = {
  sm: {
    minBlockSize: "2.125rem",
    paddingBlock: "scb2"
  },
  md: {
    minBlockSize: "2.625rem",
    paddingBlock: "scb3"
  }
};
const getMinBlockSize = createResponsive(size => sizes[size].minBlockSize);
const getPaddingBlock = createResponsive(size => sizes[size].paddingBlock);

// ----------------------
// STYLES
// ----------------------

const selectListTriggerStyles = _ref => {
  let {
    invalid,
    size = "md"
  } = _ref;
  return {
    // Reset stuff
    boxSizing: "border-box",
    outline: "none",
    position: "relative",
    cursor: "pointer",
    // Visual styles
    bg: "background",
    border: "1px solid",
    borderColor: invalid ? "border.status.critical.strong" : "border.action",
    borderRadius: "md",
    color: "foreground.strong",
    fontFamily: "default",
    fontSize: 3,
    // Display
    display: "flex",
    alignItems: "center",
    // Size and space
    gap: 1,
    inlineSize: "100%",
    minBlockSize: getMinBlockSize(size),
    paddingBlock: getPaddingBlock(size),
    paddingInline: 3,
    // Motion
    transition: _ref2 => {
      let {
        transitions
      } = _ref2;
      return transition(transitions.default, "box-shadow", "border", "opacity");
    },
    "@media (prefers-reduced-motion: reduce)": {
      transition: "none"
    },
    // Interactions
    "&:hover": {
      borderColor: invalid ? "border.status.critical.strong" : "border.action.hover"
    }
  };
};

// ----------------------
// StyledSelectListTrigger
// ----------------------

const propsNotForwarded = new Set(["contentAfter", "contentBefore", "invalid", "isOpen", "size"]);
const StyledSelectListTrigger = /*#__PURE__*/themed("button", process.env.NODE_ENV === "production" ? {
  styleProps: ["disabled", "invalid", "size"],
  shouldForwardProp: prop => !propsNotForwarded.has(prop),
  target: "ec1hp250"
} : {
  styleProps: ["disabled", "invalid", "size"],
  shouldForwardProp: prop => !propsNotForwarded.has(prop),
  target: "ec1hp250",
  label: "StyledSelectListTrigger"
})(selectListTriggerStyles, disabledStyles, focusStyles, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");

// ----------------------
// SelectListTrigger
// ----------------------

const SelectListTrigger = /*#__PURE__*/forwardRef((props, forwardedRef) => {
  const {
    children,
    contentAfter,
    contentBefore,
    disabled = false,
    invalid = false,
    isOpen = false,
    size = "md"
  } = props;
  return jsx(StyledSelectListTrigger, _extends({
    disabled: disabled,
    invalid: invalid,
    ref: forwardedRef,
    size: size
  }, props), contentBefore && jsx(Flex, {
    as: "span",
    sx: {
      color: "foreground.weak",
      flexShrink: 0,
      justifyContent: "center",
      minInlineSize: "24px"
    }
  }, contentBefore), jsx(Box, {
    as: "span",
    sx: {
      overflow: "hidden",
      flexGrow: 1,
      whiteSpace: "nowrap",
      textAlign: "start"
    }
  }, children), contentAfter && jsx(Flex, {
    as: "span",
    sx: {
      color: "foreground.weak",
      flexShrink: 0,
      justifyContent: "center",
      minInlineSize: "24px"
    }
  }, contentAfter), jsx(Flex, {
    as: "span",
    sx: {
      flexShrink: 0
    }
  }, isOpen ? jsx(ChevronUp, {
    "aria-hidden": true
  }) : jsx(ChevronDown, {
    "aria-hidden": true
  })));
});

export { SelectListTrigger };
